import { GeocodingProviderEnum, GeocodingProviderEnumValues } from '~/enums'
import { Normalization } from '~/utils/normalization'

interface ProviderRuntimeConfig {
  readonly autocompleteProvider: string
  readonly mapboxApiKey: string
}

export function selectProvider(runtimeConfig: ProviderRuntimeConfig): GeocodingProviderEnum {
  const configuredProvider = Normalization.enumValue(
    runtimeConfig.autocompleteProvider,
    GeocodingProviderEnumValues
  )

  return configuredProvider === GeocodingProviderEnum.MAPBOX &&
    Normalization.trimmedStringValue(runtimeConfig.mapboxApiKey) !== null
    ? GeocodingProviderEnum.MAPBOX
    : GeocodingProviderEnum.GOOGLE
}
